// extracted by mini-css-extract-plugin
export default {"form":"emailVerificationStep_form__AhTpB","form-btn-container":"emailVerificationStep_form-btn-container__2oZ70"};